import {
  ColumnHeader,
  CondensedPagination,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  GridSelectAllCheckbox,
  MoreMenu,
  Spinner,
  useGridForm,
  usePagination,
} from "@qw/ui";
import type { FC } from "react";
import { useDraftsFilter } from "../providers/drafts-filter-provider";
import { DraftsBulkActions } from "./drafts-bulk-actions";

export const DraftsSelectionHeader: FC<{ loading?: boolean }> = ({ loading = false }) => {
  const { hasSelection } = useGridForm();
  const { setPage } = usePagination();
  const { status, setStatus } = useDraftsFilter();

  return (
    <ColumnHeader icon={loading ? <Spinner /> : <GridSelectAllCheckbox />} className="relative z-0">
      {hasSelection && <DraftsBulkActions />}

      <div className="ml-auto flex items-center gap-1">
        <MoreMenu icon="filter_list" buttonProps={{ size: "sm" }}>
          <DropdownMenuLabel>Filter drafts</DropdownMenuLabel>
          <DropdownMenuRadioGroup
            value={status || "all"}
            onValueChange={(value) => {
              setStatus(value === "all" ? null : value);
              setPage(1);
            }}
          >
            <DropdownMenuRadioItem value="all">All</DropdownMenuRadioItem>
            <DropdownMenuRadioItem value="scheduled">Scheduled</DropdownMenuRadioItem>
            <DropdownMenuRadioItem value="failed">Failed</DropdownMenuRadioItem>
          </DropdownMenuRadioGroup>
        </MoreMenu>
        <CondensedPagination label="Drafts" loading={loading} />
      </div>
    </ColumnHeader>
  );
};
